module.exports = __webpack_public_path__ + "assets/203aed1d67d56f6f15521aed4af129e3.png";